<template>
  <ContentWrap>
    <el-collapse v-model="activeNames" class="">
      <el-collapse-item name="basicInfo">
        <template #title>
          <span class="text-base font-bold">基本信息</span>
        </template>
        <el-descriptions :column="4">
          <el-descriptions-item label="公司名称">
            {{ customer.name }}
          </el-descriptions-item>
          <el-descriptions-item label="主要联系人">{{ customer.contactName }}</el-descriptions-item>
          <el-descriptions-item label="客户来源">
            <dict-tag :type="DICT_TYPE.CRM_CUSTOMER_SOURCE" :value="customer.source" />
          </el-descriptions-item>
          <el-descriptions-item label="来源补充">{{ customer.sourceOther }}</el-descriptions-item>
          <el-descriptions-item label="联系手机">{{ customer.mobile }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ customer.telephone }}</el-descriptions-item>
          <el-descriptions-item label="微信号">{{ customer.wechat }}</el-descriptions-item>
          <el-descriptions-item label="QQ">{{ customer.qq }}</el-descriptions-item>
          <el-descriptions-item label="邮箱">{{ customer.email }}</el-descriptions-item>
          <el-descriptions-item label="其他">{{ customer.otherInfo }}</el-descriptions-item>
          <el-descriptions-item label="所在市">{{ customer.areaName }}</el-descriptions-item>
          <el-descriptions-item label="详细地址">{{ customer.detailAddress }}</el-descriptions-item>
          <el-descriptions-item label="来访线索信息" :span="4">
            {{ customer.visitLeadInfo }}
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item name="requirementInfo">
        <template #title>
          <span class="text-base font-bold">需求信息</span>
        </template>
        <el-descriptions :column="4">
          <el-descriptions-item label="需求分类">
            <dict-tag
              :type="DICT_TYPE.CRM_CUSTOMER_REQUIREMENT_CATEGORY"
              :value="customer.requirementCategoryId"
            />
          </el-descriptions-item>
          <el-descriptions-item label="需求概述" :span="3">
            {{ customer.requirementSummary }}
          </el-descriptions-item>
          <el-descriptions-item label="需求详细说明" :span="4">
            {{ customer.requirementDetail }}
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item name="attributeInfo">
        <template #title>
          <span class="text-base font-bold">客户属性</span>
        </template>
        <el-descriptions :column="4">
          <el-descriptions-item label="客户种类">
            <dict-tag :type="DICT_TYPE.CRM_CUSTOMER_CATEGORY" :value="customer.customerCategory" />
          </el-descriptions-item>
          <el-descriptions-item label="客户类型">
            <dict-tag :type="DICT_TYPE.CRM_CUSTOMER_TYPE" :value="customer.customerType" />
          </el-descriptions-item>
          <el-descriptions-item label="客户状态">
            <dict-tag :type="DICT_TYPE.CRM_CUSTOMER_STATUS" :value="customer.customerStatus" />
          </el-descriptions-item>
          <el-descriptions-item label="客户等级">
            <dict-tag :type="DICT_TYPE.CRM_CUSTOMER_LEVEL" :value="customer.level" />
          </el-descriptions-item>
          <el-descriptions-item label="所属行业">
            <dict-tag :type="DICT_TYPE.CRM_CUSTOMER_INDUSTRY" :value="customer.industryId" />
          </el-descriptions-item>
          <el-descriptions-item label="是否建群">
            <dict-tag :type="DICT_TYPE.INFRA_BOOLEAN_STRING" :value="customer.groupCreated" />
          </el-descriptions-item>
          <el-descriptions-item label="是否上市">
            <dict-tag :type="DICT_TYPE.INFRA_BOOLEAN_STRING" :value="customer.listed" />
          </el-descriptions-item>
          <el-descriptions-item label="社保人员">
            {{ customer.socialSecurityStaff }}
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item name="companyInfo">
        <template #title>
          <span class="text-base font-bold">工商与地址</span>
        </template>
        <el-descriptions :column="4">
          <el-descriptions-item label="法人代表">{{ customer.legalPerson }}</el-descriptions-item>
          <el-descriptions-item label="注册资本">
            {{ customer.registeredCapital }}
          </el-descriptions-item>
          <el-descriptions-item label="成立日期">
            {{ formatDate(customer.establishDate) }}
          </el-descriptions-item>
          <el-descriptions-item label="社保人员">
            {{ customer.socialSecurityStaff }}
          </el-descriptions-item>
          <el-descriptions-item label="官网">{{ customer.website }}</el-descriptions-item>
          <el-descriptions-item label="交通路线" :span="3">
            {{ customer.trafficRoute }}
          </el-descriptions-item>
          <el-descriptions-item label="经营范围" :span="4">
            {{ customer.businessScope }}
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item name="projectInfo">
        <template #title>
          <span class="text-base font-bold">项目与报价</span>
        </template>
        <el-descriptions :column="4">
          <el-descriptions-item label="项目是否立项">
            <dict-tag
              :type="DICT_TYPE.CRM_CUSTOMER_PROJECT_APPROVED"
              :value="customer.projectApproved"
            />
          </el-descriptions-item>
          <el-descriptions-item label="预计上线时间">
            {{ formatDate(customer.expectedOnlineTime) }}
          </el-descriptions-item>
          <el-descriptions-item label="预算">{{
            formatMoney(customer.budget)
          }}</el-descriptions-item>
          <el-descriptions-item label="报价">
            {{ formatMoney(customer.quotation) }}
          </el-descriptions-item>
          <el-descriptions-item label="报价备注" :span="4">
            {{ customer.quotationRemark }}
          </el-descriptions-item>
          <el-descriptions-item label="甲方相关文件" :span="2">
            <span v-if="!customer.partyAFiles">-</span>
            <template v-else>
              <el-link
                v-for="(url, index) in splitUrls(customer.partyAFiles)"
                :key="index"
                :href="url"
                class="mr-10px"
                target="_blank"
                type="primary"
              >
                {{ fileName(url) }}
              </el-link>
            </template>
          </el-descriptions-item>
          <el-descriptions-item label="乙方相关文件" :span="2">
            <span v-if="!customer.partyBFiles">-</span>
            <template v-else>
              <el-link
                v-for="(url, index) in splitUrls(customer.partyBFiles)"
                :key="index"
                :href="url"
                class="mr-10px"
                target="_blank"
                type="primary"
              >
                {{ fileName(url) }}
              </el-link>
            </template>
          </el-descriptions-item>
          <el-descriptions-item label="报价附件" :span="4">
            <span v-if="!customer.quotationFiles">-</span>
            <template v-else>
              <el-link
                v-for="(url, index) in splitUrls(customer.quotationFiles)"
                :key="index"
                :href="url"
                class="mr-10px"
                target="_blank"
                type="primary"
              >
                {{ fileName(url) }}
              </el-link>
            </template>
          </el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>

      <el-collapse-item name="shareInfo">
        <template #title>
          <span class="text-base font-bold">共享记录</span>
        </template>
        <el-table :data="shareList" size="small">
          <el-table-column align="center" label="共享人" prop="fromUserName" width="140" />
          <el-table-column align="center" label="被共享人" prop="toUserName" width="140" />
          <el-table-column
            :formatter="dateFormatter"
            align="center"
            label="共享时间"
            prop="shareTime"
            width="180"
          />
        </el-table>
        <el-empty v-if="shareList.length === 0" description="暂无共享记录" />
      </el-collapse-item>

      <el-collapse-item name="systemInfo">
        <template #title>
          <span class="text-base font-bold">系统信息</span>
        </template>
        <el-descriptions :column="4">
          <el-descriptions-item label="负责人">{{ customer.ownerUserName }}</el-descriptions-item>
          <el-descriptions-item label="负责人职务">
            {{ customer.ownerPosition }}
          </el-descriptions-item>
          <el-descriptions-item label="负责人备注">
            {{ customer.ownerRemark }}
          </el-descriptions-item>
          <el-descriptions-item label="下次联系时间">
            {{ formatDate(customer.contactNextTime) }}
          </el-descriptions-item>
          <el-descriptions-item label="最后跟进记录">
            {{ customer.contactLastContent }}
          </el-descriptions-item>
          <el-descriptions-item label="最后跟进时间">
            {{ formatDate(customer.contactLastTime) }}
          </el-descriptions-item>
          <el-descriptions-item label="申请人">{{ customer.creatorName }}</el-descriptions-item>
          <el-descriptions-item label="申请部门">
            {{ customer.creatorDeptName }}
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">
            {{ formatDate(customer.createTime) }}
          </el-descriptions-item>
          <el-descriptions-item label="更新时间">
            {{ formatDate(customer.updateTime) }}
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ customer.remark }}</el-descriptions-item>
        </el-descriptions>
      </el-collapse-item>
    </el-collapse>
  </ContentWrap>
</template>
<script lang="ts" setup>
import * as CustomerApi from '@/api/crm/customer'
import { DICT_TYPE } from '@/utils/dict'
import { dateFormatter, formatDate } from '@/utils/formatTime'

defineOptions({ name: 'CrmCustomerDetailsInfo' })
const { customer } = defineProps<{
  customer: CustomerApi.CustomerVO // 客户明细
}>()

const activeNames = ref([
  'basicInfo',
  'requirementInfo',
  'attributeInfo',
  'companyInfo',
  'projectInfo',
  'shareInfo',
  'systemInfo'
]) // 展示的折叠面板
const shareList = ref<CustomerApi.CustomerShareVO[]>([]) // 共享记录

/** 金额展示 */
const formatMoney = (value?: number) => {
  if (value === null || value === undefined) {
    return '-'
  }
  return `¥ ${Number(value).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`
}

/** 逗号分隔的文件 url → 数组 */
const splitUrls = (urls?: string) => (urls ? urls.split(',').filter((url) => !!url) : [])

/**
 * 从 url 中截取文件名
 *
 * ⚠️ 必须 `decodeURIComponent`：后端 `AbstractFileClient#formatFileUrl` 用 Spring 的
 * `UriUtils.encodePathSegment(seg, UTF_8)` 拼 URL，中文文件名在里面是 `%E4%BA%91...` 形态，
 * 直接截取末段会把编码串当文件名显示给用户。
 */
const fileName = (url: string) => {
  const raw = url.substring(url.lastIndexOf('/') + 1)
  if (!raw) return url
  // 去掉可能存在的 query / hash 再解码；畸形 % 序列会抛错，退回原串
  const withoutQuery = raw.split('?')[0].split('#')[0]
  try {
    return decodeURIComponent(withoutQuery)
  } catch {
    return withoutQuery
  }
}

/** 拉取共享记录 */
const loadShareList = async () => {
  if (!customer?.id) return
  shareList.value = (await CustomerApi.getCustomerShareList([customer.id])) || []
}

watch(
  () => customer?.id,
  () => loadShareList(),
  { immediate: true }
)
</script>
<style lang="scss" scoped></style>
